// frontend/src/utils/matchers.js
// 统一文本归一化：去空白 + 小写，减少目录/标题匹配误差
export const normalizeText = (value) => (value || '').replace(/\s+/g, '').toLowerCase();

export const hasRows = (tables = []) =>
  Array.isArray(tables) && tables.some((table) => Array.isArray(table?.rows) && table.rows.length > 0);

export const getDirectoryLabel = (directory) => {
  if (typeof directory === 'string') return directory;
  if (directory && typeof directory === 'object') return directory.value || directory.label || '';
  return '';
};

export const getDirectoryKeyword = (directory) => {
  const directoryText = getDirectoryLabel(directory);
  return directoryText.includes('——') ? directoryText.split('——')[1].trim() : directoryText.trim();
};

// 按目录关键词优先匹配 table.keyword，其次回退匹配标题
export const findMatchedTableByDirectory = (directory, tables = []) => {
  const keywordNorm = normalizeText(getDirectoryKeyword(directory));

  return (Array.isArray(tables) ? tables : []).find((table) => {
    const tableKeywordNorm = normalizeText(table?.keyword || '');
    const tableTitleNorm = normalizeText(table?.title || '');

    if (!keywordNorm) {
      return false;
    }

    return (
      tableKeywordNorm === keywordNorm ||
      tableTitleNorm.includes(keywordNorm) ||
      (tableKeywordNorm && keywordNorm.includes(tableKeywordNorm))
    );
  });
};